import {currentUserIsAdmin} from '@netx/core-permissions-next';
import type {IAsset} from '../schema';

export const canToggleAssetVisibility = (asset?: IAsset) => {
	if (!asset) return false;
	return currentUserIsAdmin();
};
